import React from 'react'
import Roll from 'react-reveal/Roll'
import Zoom from 'react-reveal/Zoom'
import GitHubIcon from '@material-ui/icons/GitHub'
import TwitterIcon from '@material-ui/icons/Twitter'
import LinkedInIcon from '@material-ui/icons/LinkedIn'


class Hero extends React.Component{
    render(){
        return(
            <div className="hero">
                <div className='banner'>
                    <Roll left>
                    <h3 className="banner-name">I'M DANIEL OBARE</h3>
                    </Roll>
                    <Zoom right delay={1000}>
                    <h1 className="banner-info">Data Analyst | Machine Learning Engineer</h1>
                    </Zoom>

                    <div className="d-flex justify-content-center">
                        <a href="https://Github.com/daniel-obare" target="_blank">
                            <GitHubIcon/> Github
                        </a>
                        <a className="mx-2" href="https://www.linkedin.com/in/daniel-obare" target="_blank">
                            <LinkedInIcon/> LinkedIn
                        </a>
                        <a href="https://twitter.com/DCayoty" target="_blank">
                            <TwitterIcon/> Twitter
                        </a>
                    </div>
                </div>
            </div>
        )
    }
}

export default Hero